import React from 'react';
import { Mask } from './mask';

const Menu: React.FC = ({ children }) => {
    return (
        <div className="p-editor__aside-menu">
            {children}
            <Mask type="menu" />
        </div>
    );
};

export default Menu;
